

export const getGuidanceCategoriesIndex = (categories) => {
  if (categories && categories.length > 0) {
    return categories.sort().join('+');
  }

  return 'all';
};
